import { Checkbox } from '@mui/material';
import s from './CourseCardBlock.module.scss';
import { StyledHTMLFieldsBlock } from 'components/StyledHTMLFiledsBlock/StyledHTMLFieldsBlock';
import { useEffect, useRef, useState } from 'react';
import { FileManager } from 'components/FileManager/FileManager';
import { CourseCard } from '../CourseCard/CourseCard';
import { ReactComponent as Arrow } from "../../../../../../assets/icons/arrow_tools.svg";
import { DropdownBlock } from 'components/DropdownBlock/DropdownBlock';
import { useTranslation } from 'react-i18next';

export const CourseCardBlock = ({form, setForm, activeLang, setActiveLang, dropdown, setDropDown}: any) => {

    // ### State
    const [storage, setStorage] = useState<boolean>(false)
    const description_ref = useRef<HTMLDivElement>(null)
    const {t} = useTranslation()

    // ### Effects

    // ### Functions

    // ### Views

    return(
        <div className={s.wrapper}>
            <div className={`${s.header} ${dropdown?.card ? s.active : ""}`} onClick={() => setDropDown((prev: any) => ({...prev, card: !prev.card}))}>
                <div className={`${s.arrow}`}><Arrow/></div>
                <p className={s.card_title}>{t('courses.card')}</p>
            </div>

            <DropdownBlock open={dropdown.card}>
                <div className={s.row}>

                    <div className={s.left}>
                        <div className={`${s.item} ${s.name_item}}`} ref={description_ref}>
                            <StyledHTMLFieldsBlock
                                alternativeText={form.active_card_name ? t('courses.card_name') : t('courses.card_default_name')}
                                active={form.active_card_name}
                                setActive={(value: any) => setForm((prev: any) => ({...prev, active_card_name: value}))}
                                style={{width: "100%"}}
                                values={form.card_name}
                                title={t('courses.card_name')}
                                changeValue={(value)=> setForm((prev: any) => ({...prev, card_name: {...prev.card_name, ...value}}))}
                                activeLang={activeLang}
                                setActiveLang={setActiveLang}
                                height={150}
                            />
                        </div>
                       
                        <div className={`${s.item} ${s.name_item}}`} ref={description_ref}>
                            <StyledHTMLFieldsBlock
                                alternativeText={form.active_card_description ? t('courses.card_description') : t('courses.card_default_description')}
                                active={form.active_card_description}
                                setActive={(value: any) => setForm((prev: any) => ({...prev, active_card_description: value}))}
                                style={{width: "100%"}}
                                values={form.card_description}
                                title={t('courses.card_description')}
                                changeValue={(value)=> setForm((prev: any) => ({...prev, card_description: {...prev.card_description, ...value}}))}
                                activeLang={activeLang}
                                setActiveLang={setActiveLang}
                                height={200}
                            />
                        </div>
                       
                        <div className={`${s.item} ${s.name_item}}`} ref={description_ref}>
                            <StyledHTMLFieldsBlock
                                alternativeText={form.active_card_button_text ? t('courses.card_button_text') : t('courses.card_default_button_text')}
                                active={form.active_card_button_text}
                                setActive={(value: any) => setForm((prev: any) => ({...prev, active_card_button_text: value}))}
                                style={{width: "100%"}}
                                values={form.card_button_text}
                                title={t('courses.button')}
                                changeValue={(value)=> setForm((prev: any) => ({...prev, card_button_text: {...prev.card_button_text, ...value}}))}
                                activeLang={activeLang}
                                setActiveLang={setActiveLang}
                                height={150}
                            />
                        </div>
                    </div>

                    <div className={s.right}>
                        <CourseCard
                            image={form.image}
                            title={form?.active_card_name ? form?.card_name?.[activeLang] : form?.name?.[activeLang]}
                            description={form?.active_card_description ? form?.card_description?.[activeLang] : form?.description?.[activeLang]}
                            active_price={form.active_price}
                            active_discount={form.active_discount}
                            price={form.price}
                            discount={form.discount}
                            form={form}
                            setForm={setForm}
                            storageType="image"
                            activeLang={activeLang}
                            setActiveLang={setActiveLang}
                        />
                    </div>
                </div>
            </DropdownBlock>
            
            {
                storage ? 
                <FileManager 
                    isModal={true}
                    setIsOpenStorage={() => setStorage(false)}
                    type='image'
                    setFile={(link) =>  setForm((prev: any) => ({...prev, image: link}))}
                /> : null
            }
        </div>
    )
}